module.exports = {"pt-BR":{"timeline":{"property-close-rent-card":{"rent":"Encerrou o aluguel"}}}}